/**
 * All block descriptions and titles are copied here.
 */
/**
 * WordPress dependencies
 */
import { __, _x } from '@wordpress/i18n'

/**
 * External dependencies
 */
import { i18n } from 'stackable'

const blocks = {
	'ugb/accordion': {
		title: _x( 'Accordion', 'block title', i18n ),
	},
	'ugb/text': {
		title: _x( 'Advanced Text', 'block title', i18n ),
	},
	'ugb/heading': {
		title: _x( 'Advanced Heading', 'block title', i18n ),
	},
	'ugb/blockquote': {
		title: _x( 'Blockquote', 'block title', i18n ),
	},
	'ugb/blog-posts': {
		title: _x( 'Blog Posts', 'block title', i18n ),
	},
	'ugb/button': {
		title: _x( 'Button', 'block title', i18n ),
	},
	'ugb/cta': {
		title: _x( 'Call to Action', 'block title', i18n ),
	},
	'ugb/card': {
		title: _x( 'Card', 'block title', i18n ),
	},
	'ugb/columns': {
		title: _x( 'Columns', 'block title', i18n ),
	},
	'ugb/container': {
		title: _x( 'Container', 'block title', i18n ),
	},
	'ugb/count-up': {
		title: _x( 'Count Up', 'block title', i18n ),
	},
	// 'ugb/design-library': {
	// 	title: _x( 'Design Library', 'block title', i18n ),
	// },
	'ugb/divider': {
		title: _x( 'Divider', 'block title', i18n ),
	},
	'ugb/expand': {
		title: _x( 'Expand / Show More', 'block title', i18n ),
	},
	'ugb/feature-grid': {
		title: _x( 'Feature Grid', 'block title', i18n ),
	},
	'ugb/feature': {
		title: _x( 'Feature', 'block title', i18n ),
	},
	'ugb/header': {
		title: _x( 'Header', 'block title', i18n ),
	},
	'ugb/icon': {
		title: _x( 'Icon', 'block title', i18n ),
	},
	'ugb/icon-list': {
		title: _x( 'Icon List', 'block title', i18n ),
	},
	'ugb/image-box': {
		title: _x( 'Image Box', 'block title', i18n ),
	},
	'ugb/notification': {
		title: _x( 'Notification', 'block title', i18n ),
	},
	'ugb/number-box': {
		title: _x( 'Number Box', 'block title', i18n ),
	},
	'ugb/pricing-box': {
		title: _x( 'Pricing Box', 'block title', i18n ),
	},
	'ugb/separator': {
		title: _x( 'Separator', 'block title', i18n ),
	},
	'ugb/spacer': {
		title: _x( 'Spacer', 'block title', i18n ),
	},
	'ugb/team-member': {
		title: _x( 'Team Member', 'block title', i18n ),
	},
	'ugb/testimonial': {
		title: _x( 'Testimonial', 'block title', i18n ),
	},
	'ugb/video-popup': {
		title: _x( 'Video Popup', 'block title', i18n ),
	},
}

export default blocks
